import styled, { css } from 'styled-components';

// One look for stored HTML, so what's formatted in the editor shows the same
// on the detail pages.
export const richContentCss = css`
  color: var(--grey-900);
  font-size: 0.9375rem;
  line-height: 1.6;

  p {
    margin: 0 0 0.75rem;
  }

  & > :last-child,
  blockquote > :last-child {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4 {
    color: var(--grey-900);
    font-weight: 600;
    margin: 1.25rem 0 0.5rem;
  }

  h1 {
    font-size: 1.25rem;
  }

  h2 {
    font-size: 1.125rem;
  }

  h3,
  h4 {
    font-size: 1rem;
  }

  & > :first-child {
    margin-top: 0;
  }

  img {
    border-radius: 4px;
    display: block;
    height: auto;
    margin: 0.75rem 0;
    max-width: 100%;
  }

  ul,
  ol {
    margin: 0 0 0.75rem;
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.25rem;
  }

  blockquote {
    background: var(--grey-75);
    border-left: 4px solid var(--grey-450);
    border-radius: 0 0.25rem 0.25rem 0;
    color: var(--grey-800);
    font-style: italic;
    margin: 0.75rem 0;
    padding: 0.5rem 1rem;
  }

  a {
    color: var(--blue);
  }

  .blank {
    background: color-mix(in srgb, var(--success) 14%, transparent);
    border-bottom: 2px solid var(--success);
    display: inline-block;
    font-weight: 600;
    min-width: 4rem;
    padding: 0 0.375rem;
    text-align: center;
  }
`;

export const RichContent = styled.div`
  ${richContentCss}
`;
